/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const WorkforceProjectStatus = {
    Ongoing: 'ONGOING',
    Completed: 'COMPLETED'
} as const;
export type WorkforceProjectStatus = typeof WorkforceProjectStatus[keyof typeof WorkforceProjectStatus];


export function instanceOfWorkforceProjectStatus(value: any): boolean {
    for (const key in WorkforceProjectStatus) {
        if (Object.prototype.hasOwnProperty.call(WorkforceProjectStatus, key)) {
            // @ts-ignore
            if (WorkforceProjectStatus[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function WorkforceProjectStatusFromJSON(json: any): WorkforceProjectStatus {
    return WorkforceProjectStatusFromJSONTyped(json, false);
}

export function WorkforceProjectStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkforceProjectStatus {
    return json as WorkforceProjectStatus;
}

export function WorkforceProjectStatusToJSON(value?: WorkforceProjectStatus | null): any {
    return value as any;
}

